export function confirmDelete(message = 'This action cannot be undone.') {
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px;font-family:Inter,sans-serif;';
    overlay.innerHTML = `
      <div style="background:#fff;border-radius:12px;padding:24px;width:100%;max-width:380px;box-shadow:0 8px 32px rgba(0,0,0,0.2);" onclick="event.stopPropagation()">
        <div style="display:flex;align-items:center;gap:10px;margin-bottom:12px;">
          <div style="width:38px;height:38px;background:#fcebeb;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#a32d2d" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14H6L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4h6v2"></path></svg>
          </div>
          <div>
            <div style="font-size:15px;font-weight:500;color:#0f172a;">Confirm permanent delete</div>
            <div style="font-size:12px;color:#64748b;max-width:280px;">${message}</div>
          </div>
        </div>
        <div style="margin-bottom:16px;">
          <label style="font-size:11px;font-weight:500;color:#64748b;text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:6px;">Enter password to confirm</label>
          <input id="del-pwd" type="password" placeholder="Enter password"
            style="width:100%;box-sizing:border-box;padding:9px 12px;border:1px solid #cbd5e1;border-radius:8px;font-size:14px;font-family:inherit;outline:none;"/>
          <div id="del-err" style="font-size:12px;color:#a32d2d;margin-top:4px;display:none;">Incorrect password. Try again.</div>
        </div>
        <div style="display:flex;gap:8px;">
          <button id="del-cancel" style="flex:1;padding:10px;border-radius:8px;border:1px solid #cbd5e1;background:transparent;color:#64748b;font-size:13px;cursor:pointer;font-family:inherit;">Cancel</button>
          <button id="del-ok" style="flex:1;padding:10px;border-radius:8px;border:none;background:#a32d2d;color:#fff;font-size:13px;font-weight:500;cursor:pointer;font-family:inherit;">Delete permanently</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    const input = overlay.querySelector('#del-pwd');
    const err   = overlay.querySelector('#del-err');
    setTimeout(() => input?.focus(), 50);
    const cleanup = (r) => { document.body.removeChild(overlay); resolve(r); };
    const attempt = () => { if (input.value === '1234') cleanup(true); else { err.style.display='block'; input.value=''; input.focus(); } };
    overlay.querySelector('#del-cancel').addEventListener('click', () => cleanup(false));
    overlay.addEventListener('click', () => cleanup(false));
    overlay.querySelector('#del-ok').addEventListener('click', attempt);
    input.addEventListener('keydown', e => { if (e.key==='Enter') attempt(); if (e.key==='Escape') cleanup(false); });
  });
}
